// extracted by mini-css-extract-plugin
export var active = "_62-a";
export var activeIndicator = "_62-9";
export var disabled = "_62-b";
export var fullWidth = "_62-2";
export var lg = "_62-7";
export var md = "_62-6";
export var redoButtonTabGroup = "_62-0";
export var sm = "_62-5";
export var tabButton = "_62-4";
export var tabButtonsContainer = "_62-1";
export var themeDestructive = "_62-d";
export var themeNormal = "_62-c";
export var themeSuccess = "_62-e";
export var xl = "_62-8";
export var xs = "_62-3";